import TooltipCode from "!!raw-loader!./tooltips/Design.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Tooltip from "./tooltips/Design";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Tooltips", TooltipCode, Tooltip),
	];

	return (
		<Pane
			components={components}
			imports={"import { Tooltip } from \"designSystem/index\";"}
			muiApi="tooltip"
			muiComponent="tooltips"
			{...props}
		/>
	);
};